<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"
             :width="100"
             :height="100"
             :color="spinnerColor"
             :opacity="0"
             :background-color="backgroundColor" />
  </div>
</template>

<script>
// eslint-disable-next-line
import Loading from 'vue-loading-overlay';

export default {
  name: 'LoadingOverlay',
  data() {
    return {
      isLoading: true,
      fullPage: true,
      spinnerColor: '#0066ff',
      backgroundColor: '000000',
    };
  },
  components: {
    Loading,
  },
};
</script>

<style lang="scss" scoped>

</style>
